import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FormWrapper from '../FormWrapper';

const VerifyCodeForm = () => {
  const navigate = useNavigate();

  const [resetProcessId, setResetProcessId] = useState<string | null>(null); 
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false); 
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const storedId = localStorage.getItem('resetProcessId');
    if (storedId) {
      setResetProcessId(storedId);
    } else {
      setError('خطا: شناسه فرآیند بازیابی موجود نیست. لطفاً مراحل بازیابی را مجدداً طی کنید.');
      setTimeout(() => navigate('/forgot-password'), 3000);
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    setError('');
    setMessage('');

    if (!resetProcessId) {
      setError('شناسه فرآیند بازیابی نامعتبر است.');
      setLoading(false);
      return;
    }
    if (!verificationCode) {
      setError('لطفاً کد بازیابی را وارد کنید.');
      setLoading(false);
      return;
    }

    setMessage('کد بازیابی دریافت شد. به صفحه تنظیم رمز عبور جدید هدایت می‌شوید...');
    localStorage.setItem('resetPasswordCode', verificationCode);
    localStorage.setItem('resetProcessId', resetProcessId); 

    setTimeout(() => {
      navigate('/reset-password'); 
    }, 1500); 
    setLoading(false); 
  };

  if (!resetProcessId) {
    return (
      <FormWrapper title="تایید کد بازیابی" subtitle="خطا" currentStep={2} totalSteps={3}>
        <div className="error-message">{error}</div>
        <div className="form-footer" style={{marginTop: '1rem'}}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/forgot-password'); }} style={{cursor: 'pointer'}}>
            درخواست کد جدید
          </a>
        </div>
      </FormWrapper>
    );
  }

  return (
    <FormWrapper
      title="تایید کد بازیابی"
      subtitle={`کد ارسال شده را وارد کنید.`} 
      currentStep={2}
      totalSteps={3} 
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <div className="input-group">
          <label htmlFor="verificationCode">کد بازیابی</label>
          <input
            type="text"
            id="verificationCode"
            name="verificationCode"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder="کد بازیابی را وارد کنید"
            required
            disabled={loading}
            autoFocus
          />
        </div>

        <button type="submit" className="main-btn" disabled={loading} style={{width: '100%', marginTop: '1rem'}}>
          {loading ? 'در حال بررسی...' : 'تایید کد'}
        </button>
        
        <div className="form-footer">
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/forgot-password'); }} style={{cursor: 'pointer'}}>
              درخواست کد جدید
            </a>
        </div>
      </form>
    </FormWrapper>
  );
};

export default VerifyCodeForm;